module.exports = __webpack_public_path__ + "static/media/fibra-optica.390aa2b0.jpg";